var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "For-Brock---FINAL-Whole-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SIGNUP",
    transform: "translate(-882, -403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(842, 403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(40, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#61849D",
    cx: 26,
    cy: 26,
    r: 26
  }), /*#__PURE__*/React.createElement("g", {
    id: "quotation-mark",
    transform: "translate(15, 16)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.26590488,0.881653941 L9.26590488,4.47275541 C9.26590488,4.95978891 8.87109949,5.35440935 8.38406599,5.35440935 C6.64640443,5.35440935 5.70118953,7.13664372 5.57018369,10.654197 L8.38406599,10.654197 C8.87109949,10.654197 9.26590488,11.0491873 9.26590488,11.5360359 L9.26590488,19.1184694 C9.26590488,19.6052563 8.87109949,19.9999384 8.38406599,19.9999384 L0.881653941,19.9999384 C0.394435488,19.9999384 0,19.604948 0,19.1184694 L0,11.5360359 C0,9.84979024 0.169783578,8.30237999 0.5044804,6.93628184 C0.847746545,5.53553649 1.37466748,4.31080136 2.07013899,3.29598382 C2.78576999,2.25305398 3.68092524,1.43465274 4.73094481,0.864515294 C5.78805412,0.290925456 7.01735134,0 8.38437424,0 C8.87109949,0 9.26590488,0.394620438 9.26590488,0.881653941 Z M20.638692,5.354471 C21.1254789,5.354471 21.5205926,4.95948066 21.5205926,4.47281706 L21.5205926,0.881715591 C21.5205926,0.394682087 21.1255406,6.1649811e-05 20.638692,6.1649811e-05 C19.272224,6.1649811e-05 18.0427418,0.291048756 16.9860024,0.864576944 C15.9357979,1.43471439 15.0401494,2.25311563 14.3243951,3.29604547 C13.6291702,4.310863 13.1022493,5.53565979 12.7589215,6.93671339 C12.4244096,8.30324309 12.254626,9.85065333 12.254626,11.5360975 L12.254626,19.118531 C12.254626,19.6053179 12.6495547,20 13.1364649,20 L20.6386304,20 C21.1254173,20 21.520161,19.6050097 21.520161,19.118531 L21.520161,11.5360359 C21.520161,11.049249 21.1254789,10.654197 20.6386304,10.654197 L17.8648821,10.654197 C17.9939152,7.13670537 18.9253205,5.354471 20.638692,5.354471 Z",
    id: "Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.f676dd5aa573d0cf0cdf734229d3b975.svg";
export { ForwardRef as ReactComponent };